import { Loader } from 'braid-design-system';
import { useEffect } from 'react';
import { BasePage } from '#src/components/BasePage/BasePage.tsx';

export const AuthorizePage = () => {
  // Auth0 should manage this for us, but add a backup redirect just in case
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      window.location.replace('/manage');
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <BasePage breadcrumbs={null} title="Logging in">
      <Loader />
    </BasePage>
  );
};
